'use client';

import { c as _c } from "react/compiler-runtime";
import { type ListItem, ListSelection } from '@/app/components/forms/list-selection';
import { CustomSelection } from '@/app/lcv/components/sections/calculator/configure/custom-selection';
import { safeCall } from '@/app/utils/safeCall';
import type { LcvModelCategory } from '@/types/tis-cms/types';
interface ModelCategorySelectionProps {
  isOpen: boolean;
  toggle: () => void;
  list: LcvModelCategory[];
  value: string;
  selectedModelCategory: LcvModelCategory;
  onSelectedList?: (category: LcvModelCategory) => void;
}
export const ModelCategorySelection = t0 => {
  const $ = _c(18);
  const {
    isOpen,
    toggle,
    list: t1,
    value,
    selectedModelCategory,
    onSelectedList
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const list = t2;
  let t3;
  if ($[2] !== list) {
    t3 = list.map(_temp);
    $[2] = list;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const items = t3;
  let t4;
  if ($[4] !== list || $[5] !== onSelectedList || $[6] !== toggle) {
    t4 = item => {
      toggle();
      const selectedCategory = list.find(c => c.documentId === item.uid);
      if (selectedCategory) {
        safeCall(onSelectedList, selectedCategory);
      }
    };
    $[4] = list;
    $[5] = onSelectedList;
    $[6] = toggle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onSelect = t4;
  let t5;
  if ($[8] !== isOpen || $[9] !== items || $[10] !== list.length || $[11] !== onSelect || $[12] !== selectedModelCategory || $[13] !== toggle || $[14] !== value) {
    t5 = list?.length > 0 && <div className="cursor-pointer space-y-2" onClick={toggle}><CustomSelection test="model-category" title={"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E38\u0E48\u0E19\u0E23\u0E16"} value="accordion-model-category" selectedValue={<>{selectedModelCategory.nameTh}</>} isOpen={isOpen} onChange={toggle} content={<ListSelection items={items} value={value} onSelected={onSelect} />} /></div>;
    $[8] = isOpen;
    $[9] = items;
    $[10] = list.length;
    $[11] = onSelect;
    $[12] = selectedModelCategory;
    $[13] = toggle;
    $[14] = value;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <>{t5}</>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
function _temp(mc) {
  return {
    uid: mc.documentId,
    name: mc.nameTh
  };
}